import type { OpenCallTag } from "../types";

/**
 * Returns a theme color string based on the open call's tag
 */
function getOpenCallTagColor(tag: OpenCallTag): string {
  if (["Coming Soon", "Voting Soon"].includes(tag)) {
    return "accent2";
  }

  if (["Voting Open", "Submissions Open"].includes(tag)) {
    return "successDAlt";
  }

  if (tag === "Under Curation") return "accent2";

  if (["Artists Selected", "Concluded", "On Display"].includes(tag)) {
    return "fg40";
  }

  return "";
}

export { getOpenCallTagColor };
